module.exports = __webpack_public_path__ + "static/media/mikublink.3301ca63.gif";